export default "__VITE_ASSET__DpH14Op3__"